export function convertBrToP(htmlContent) {
    // Replace all <br> tags with </p><p>
    const replacedContent = htmlContent.replace(/<br\s*[/]?>/gi, '</p><p>');
      
    // Wrap the content with <p> tags
    let wrappedContent = `${replacedContent}`;
  
    return wrappedContent;
  }  